<template>
  <div class="main-content">
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col-12 col-md-5 col-xl-6">
          <h2 class="header-title">Список документов</h2>
        </div>
        <div class="col-12 col-md-7 col-xl-6 d-flex">
          
        </div>
      </div>
    </div>
    <!-- Content goes Here -->
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-md-4 col-lg-4">
            <div class="form-group">
              <label for="select_1_1">Факультет <span>*</span></label>
              <select
                class="form-control"
                id="select_1_1"
                v-model="fak.val"
                @change="fakSelect"
                :disabled="fak.disabled"
                required
              >
                <option value="0" selected disabled>
                  -- выбрать факультет --
                </option>
                <template v-if="fak.items != null">
                  <option
                    v-for="item in fak.items"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.name_kg }}
                  </option>
                </template>
              </select>
            </div>
          </div>
          <div class="col-md-4 col-lg-4">
            <div class="form-group">
              <label for="select_1_11">Направления <span>*</span></label>
              <select
                class="form-control"
                id="select_1_11"
                v-model="direction.val"
                @change="directionSelect"
                :disabled="fak.val == 0"
                required
              >
                <option value="0" selected disabled>
                  -- выбрать направления --
                </option>
                <template v-if="direction.items != null">
                  <option
                    v-for="item in direction.items"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.name_kg }}
                  </option>
                </template>
              </select>
            </div>
          </div>
          <div class="col-md-4 col-lg-4">
            <div class="form-group">
              <label for="select_1_2">Специальность <span>*</span></label>
              <select
                class="form-control"
                id="select_1_2"
                v-model="spec.val"
                @change="specSelect"
                :disabled="direction.val == 0"
                required
              >
                <option value="0" selected disabled>
                  -- выбрать специальность --
                </option>
                <template v-if="spec.items != null">
                  <option
                    v-for="item in spec.items"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.name_kg }}
                  </option>
                </template>
              </select>
            </div>
          </div>
          <div class="col-md-4 col-lg-2">
            <div class="form-group">
              <label for="select_1_4">Тип обучения<span>*</span></label>
              <select
                class="form-control"
                id="select_1_4"
                v-model="type_o.val"
                @change="type_oSelect"
                :disabled="spec.val == 0"
                required
              >
                <option value="0" selected disabled>---</option>
                <template v-if="type_o.items != null">
                  <option
                    v-for="item in type_o.items"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.name }}
                  </option>
                </template>
              </select>
            </div>
          </div>
          <div class="col-md-4 col-lg-2">
            <div class="form-group">
              <label for="select_1_5">Форма обучения<span>*</span></label>
              <select
                class="form-control"
                id="select_1_5"
                v-model="f_o.val"
                :disabled="type_o.val == 0"
                @change="f_oSelect"
                required
              >
                <option value="0" selected disabled>---</option>
                <template v-if="f_o.items != null">
                  <option
                    v-for="item in f_o.items"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.name }}
                  </option>
                </template>
              </select>
            </div>
          </div>
          <div class="col-md-4 col-lg-2">
            <div class="form-group">
              <label for="select_1_6">Тур <span>*</span></label>
              <select
                class="form-control"
                id="select_1_6"
                v-model="tur.val"
                :disabled="f_o.val == 0"
                @change="turSelect"
              >
                <option value="0" selected disabled>---</option>
                <template v-if="tur != null">
                  <option
                    v-for="item in tur.items"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.name }}
                  </option>
                </template>
              </select>
            </div>
          </div>
          <div class="col">
            <div class="h-100 d-flex justify-content-end align-items-end">
              <button
                type="button"
                class="btn btn-primary mb-4"
                @click.prevent="exToggle"
              >Экз. лист</button>
            </div>            
          </div>          
        </div>
        <template v-if="is_ex">
          <hr class="mt-0 mb-2" />
          <div class="row">
            <div class="col-md-3">
              <div class="form-group">
                <label for="select_1_6">Предмет 1</label>
                <select
                  class="form-control"
                  id="select_1_6"
                  v-model="exam_subject1.id"
                  :disabled="exam_subject1.items.length==0"                    
                >
                  <option value="null" selected disabled>---</option>
                  <template v-if="exam_subject1.items.length">
                    <option
                      v-for="item in exam_subject1.items"
                      :key="item.id"
                      :value="item.id"
                    >
                      {{ item.name }}
                    </option>
                  </template>
                </select>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label for="select_1_3">Предмет 2</label>
                <select
                  class="form-control"
                  id="select_1_6"
                  v-model="exam_subject2.id"
                  :disabled="exam_subject2.items.length==0"                    
                >
                  <option :value="null" selected>---</option>
                  <template v-if="exam_subject2.items.length">
                    <option
                      v-for="item in exam_subject2.items"
                      :key="item.id"
                      :value="item.id"
                    >
                      {{ item.name }}
                    </option>
                  </template>
                </select>
              </div>
            </div>
            <div class="col-md-2">
              <div class="form-group">
                <label for="select_1_3">Уруксат берилген күнү</label>
                <input type="date" class="form-control" v-model="exData.date1"/>
              </div>
            </div>
            <div class="col-md-2">
              <div class="form-group">
                <label for="select_1_3">Берилген күнү</label>
                <input type="date" class="form-control" v-model="exData.date2"/>
              </div>
            </div>
            <div class="col-md-2">
              <div class="form-group">
                <label for="select_1_3">Токтом №</label>
                <input type="text" class="form-control" v-model="exData.toktom"/>
              </div>
            </div>
          </div>       
        </template>
        <hr class="mt-0 mb-2" />
        <template  v-if="optionsBlock || status">
          <div class="row align-items-center">
            <div class="col-auto mb-2" v-if="documets.data.length">
              <span class="mr-3"> {{ perPage }} из {{ documets.total }} </span>
              <span class="mr-2">Покозать:</span>
              <select
                class="custom-select custom-select-sm"
                style="width: 5em"
                v-model="perPage"
                @change="perPageChange"
              >
                <option
                  v-for="(item, index) in perPageArr"
                  :value="item"
                  :key="index"
                >
                  {{ item }}
                </option>
              </select>
            </div>
            <div class="col-auto ml-auto mb-2">
              <div class="row">
                <div class="col-auto">
                  <div class="input-affix ">
                    <i class="prefix-icon anticon anticon-search"></i>
                    <input type="text" class="form-control form-control-sm" v-model.trim="searchByFio" placeholder="Поиск" @input="searchInput" @keydown.enter="searchFio">
                    <i class="suffix-icon close anticon anticon-close" v-if="searchByFio.length" @click="searchClear"></i>
                  </div>
                </div>
                <div class="col-auto">                  
                  <button
                    class="btn btn-sm btn-icon btn-secondary btn-tone excel"
                    :disabled="!documets.data.length"
                    :class="{ excelHide: !documets.data.length }"
                    @click="downloadFile"
                  >
                    <i class="anticon anticon-file-excel"></i>
                  </button>
                </div>
                <div class="col-auto">
                  <div class="filter">
                    <button
                      class="btn btn-icon btn-sm btn-default btn-tone mr-1 mb-1 mb-lg-0 all"
                      @click="fAllCheck"
                      :class="{'active': !isAllfilter}"
                    >
                      Все
                    </button>
                    
                    <a href="#"
                      class="btn btn-icon btn-sm btn-default btn-tone mr-1 mb-1 mb-lg-0"
                      @click.prevent="f_proverka"
                      :class="{'active': filter.status_proverka}"
                    >
                      <i class="anticon anticon-save"></i>
                    </a>
                    <a href="#"
                      class="btn btn-icon btn-sm btn-default btn-tone mr-1 mb-1 mb-lg-0"
                      @click.prevent="f_prinyat"
                      :class="{'active': filter.status_prinyat}"
                    >
                      <i class="anticon anticon-check"></i>
                    </a>
                    <a href="#"
                      class="btn btn-icon btn-sm btn-default btn-tone mr-1 mb-1 mb-lg-0"
                      @click.prevent="f_print"
                      :class="{'active': filter.status_print}"
                    >
                      <i class="anticon anticon-printer"></i>
                    </a>
                    <a href="#"
                      class="btn btn-icon btn-sm btn-default  btn-tone mr-1 mb-1 mb-lg-0"
                      @click.prevent="f_avn"
                      :class="{'active': filter.status_avn}"
                    >
                      <i class="anticon anticon-export"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr class="mt-0 mb-2" />
        </template>
        <template v-if="documets.data.length">
          <table 
            class="table table-responsive-md table-striped table-hover table-sm"
          >
            <thead class="">
              <tr>
                <th scope="col">#</th>
                <th scope="col">Ф.И.О</th>
                <th scope="col">Страна</th>
                <th scope="col">Область</th>
                <th scope="col">Район</th>
                <th scope="col">Дата рег.</th>
                <th scope="col">№ приказа </th>
                <th scope="col">Дата приказа </th>
                <th scope="col"></th>
                <th scope="col" v-if="is_exBtn"></th>
                <th scope="col"></th>
                <th scope="col" class="text-center"><i class="anticon anticon-ordered-list "></i></th>
                <th scope="col" class="text-right filter"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in documets.data" :key="item.id">
                <th scope="row">{{ (page - 1) * perPage + (index + 1) }}</th>
                <td>{{ item.f }} {{ item.i }} {{ item.o }}</td>
                <td>{{ item.country_school_name.name_kg }}</td>
                <td>{{ item.oblast_school_name.name_kg }}</td>
                <td>{{ item.rayon_school_name.name_kg }}</td>
                <td>
                  {{ new Date(item.created_at).toLocaleString().substring(0, 10) }}
                </td>
                <td>
                  <template v-if="item.order_n">
                    <b style="color: #FF9800">{{ item.order_n }}</b>
                  </template>
                </td>
                <td>
                  <template v-if="item.order_date">
                    <b style="color: #FF9800">{{ new Date(item.order_date).toLocaleString().substring(0, 10) }}</b>
                  </template>
                </td>

                <td>
                  <button
                    class="btn btn-icon btn-sm btn-success btn-tone mr-1 mb-1 mb-lg-0"
                    @click="goStatement(item.id)"
                  >
                    <i class="anticon anticon-edit"></i>
                  </button>
                </td>
                <td v-if="is_exBtn">
                  <button
                    class="btn btn-sm btn-secondary btn-tone excel wsnw"
                    :disabled="!item.status_print"
                    :class="{ excelHide: !item.status_print}"
                    @click="printPDF(item)"
                  > 
                    Экз. лист <i class="anticon anticon-printer"></i>
                  </button>
                </td>
                <td>                  
                  <button
                    class="btn btn-icon btn-sm btn-success btn-tone"
                    @click="status_avn_api(item.id)"
                    :disabled="!item.status_print"
                  >
                    <i class="anticon anticon-export"></i>
                  </button>
                </td>
                <td>
                  <button
                    class="btn btn-icon btn-sm btn-success btn-tone"
                    @click="enrollmentModalShow(item)"
                    :disabled="!item.status_print"
                  >
                    <i class="anticon anticon-ordered-list "></i>
                  </button>
                </td>
                <td class="text-right">
                  <!-- <button class="btn btn-primary btn-xs mr-1">btn-xs</button> -->
                  <div
                    class="statusIcon mr-1 mb-1 mb-lg-0"
                    :class="{ status_prinyat: item.status_proverka }"
                  >
                    <i class="anticon anticon-save"></i>
                  </div>
                  <div
                    class="statusIcon mr-1 mb-1 mb-lg-0"
                    :class="{ status_prinyat: item.status_prinyat }"
                  >
                    <i class="anticon anticon-check"></i>
                  </div>
                  <div
                    class="statusIcon mr-1 mb-1 mb-lg-0"
                    :class="{ status_prinyat: item.status_print }"
                  >
                    <i class="anticon anticon-printer"></i>
                  </div>
                  <div
                    class="statusIcon mr-1 mb-1 mb-lg-0"
                    :class="{ status_prinyat: item.status_avn }"
                  >
                    <i class="anticon anticon-export"></i>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <hr />
        </template>
        <template v-else>
          <div v-if="dataLoading" class="loadData"><i class="anticon anticon-loading"></i></div>
          <div v-else class="noTdData">Нет данных</div>          
        </template>        
        <nav class="d-flex justify-content-center" v-if="documets.data.length">
          <ul class="pagination">
            <li
              class="page-item"
              v-for="(item, i) in documets.links"
              :key="i"
              :class="{ active: item.active, disabled: item.url == null }"
              @click.prevent="slectPage(i)"
            >
              <a class="page-link" href="#">
                <template v-if="item.label === '&laquo; Previous'">
                  <i class="anticon anticon-double-left"></i>
                </template>
                <template v-else-if="item.label === 'Next &raquo;'">
                  <i class="anticon anticon-double-right"></i>
                </template>
                <template v-else>{{ item.label }}</template>
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
    <Modal :isShow="enrollmentModal" :mWidth="1000" @closeModal="enrollmentModal = false">

      <template v-slot:title>Регистрация в MYEDU</template>
      <template>
        <div class="row">
          <div class="col-md-6 br1">
            <h3 class="text-center">Registration</h3>
            <div class="d-flex mb-4">
              <div class="e_img mr-4" style="width: 170px">
                <img :src="enrollmentData.foto" alt="" class="img-fluid">
              </div>
              <div class="flex-grow-1">
                <h5>{{ enrollmentData.f }}</h5>
                <h5>{{ enrollmentData.i }}</h5>
                <h5 class="mb-0">{{ enrollmentData.o }}</h5>
                <hr class="mt-2 mb-2">
                <div class="mb-2 d-flex justify-content-between">
                  <span class="mr-3">Окуу тиби: </span>
                  <span class="font-weight-bold">{{ enrollmentData.type_o }}</span>
                </div>
                <div class="mb-2 d-flex justify-content-between">
                  <span class="mr-3">Окуу формасы: </span>
                  <span class="font-weight-bold">{{ enrollmentData.f_o }}</span>
                </div>
                <div class="mb-2 d-flex justify-content-between">
                  <span class="mr-3">Окуу тили: </span>
                  <span class="font-weight-bold">{{ enrollmentData.language_o_name }}</span>
                </div>
                <div class="mb-2 d-flex justify-content-between">
                  <span class="mr-3">Жарандыгы: </span>
                  <span class="font-weight-bold">{{ enrollmentData.citizenship_name }}</span>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <a :href="enrollmentData.passport1_file" target="_blank">
                  <img :src="enrollmentData.passport1_file" alt="" class="img-fluid">
                </a>
              </div>
              <div class="col-md-4">
                <a :href="enrollmentData.passport2_file" target="_blank">
                  <img :src="enrollmentData.passport2_file" alt="" class="img-fluid">
                </a>
              </div>
              <div class="col-md-4">
                <a :href="enrollmentData.ort_file" target="_blank">
                  <img :src="enrollmentData.ort_file" alt="" class="img-fluid">
                </a>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <h3 class="text-center">MYEDU</h3>
            <div class="form-group mb-2">
              <label for="select_1_1">Факультет <span>*</span></label>
              <select
                class="custom-select"
                id="select_1_1"
                v-model="m_fak.id"
                @change="getMYEDU_Dir"
                :disabled="false"
                required
              >
                <option value="null" selected disabled>-- выбрать факультет --</option>
                <template v-if="m_fak.items != null">
                  <option
                    v-for="item in m_fak.items"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.name_kg }}
                  </option>
                </template>
              </select>
            </div>
            <div class="form-group mb-2">
              <label for="select_1_1">Багыт <span>*</span></label>
              <select
                class="custom-select"
                id="select_1_1"
                v-model="m_direction.id"
                @change="getMYEDU_Spec"
                :disabled="!m_fak.id"
                required
              >
                <option value="null" selected disabled>-- выбрать направления --</option>
                <template v-if="m_direction.items != null">
                  <option
                    v-for="item in m_direction.items"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.name_kg }}
                  </option>
                </template>
              </select>
            </div>
            <div class="form-group mb-2">
              <label for="select_1_1">Адистик <span>*</span></label>
              <select
                class="custom-select"
                id="select_1_1"
                v-model="m_spec.id"
                @change="{}"
                :disabled="!m_direction.id"
                required
              >
                <option value="null" selected disabled>-- выбрать специальность --</option>
                <template v-if="m_spec.items != null">
                  <option v-for="item in m_spec.items" :key="item.id" :value="item.id">
                    {{ item.name_kg }}
                  </option>
                </template>
              </select>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group mb-2">
                  <label for="select_1_1">Окуу жылы <span>*</span></label>
                  <select
                    class="custom-select"
                    id="select_1_1"
                    v-model="m_eduyear.id"
                    required
                  >
                    <option value="null" selected disabled>-- выбрать --</option>
                    <template v-if="m_eduyear.items != null">
                      <option v-for="item in m_eduyear.items" :key="item.id" :value="item.id">
                        {{ item.name_kg }}
                      </option>
                    </template>
                  </select>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-2">
                  <label for="select_1_1">Период <span>*</span></label>
                  <select
                    class="custom-select"
                    id="select_1_1"
                    v-model="m_period.id"
                    required
                  >
                    <option value="null" selected disabled>-- выбрать --</option>
                    <template v-if="m_period.items != null">
                      <option v-for="item in m_period.items" :key="item.id" :value="item.id">
                        {{ item.name_kg }}
                      </option>
                    </template>
                  </select>
                </div>
              </div>
            </div>
            <div class="form-group mb-2">
              <label for="select_1_1">Окуу формасы <span>*</span></label>
              <select
                class="custom-select"
                id="select_1_1"
                v-model="m_eduform.id"
                required
              >
                <option value="null" selected disabled>-- выбрать --</option>
                <template v-if="m_eduform.items != null">
                  <option v-for="item in m_eduform.items" :key="item.id" :value="item.id">
                    {{ item.name_kg }}
                  </option>
                </template>
              </select>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group mb-2">
                  <label for="select_1_1">Окуу тиби <span>*</span></label>
                  <select
                    class="custom-select"
                    id="select_1_1"
                    v-model="m_paymentform.id"
                    required
                  >
                    <option value="null" selected disabled>-- выбрать --</option>
                    <template v-if="m_paymentform.items != null">
                      <option v-for="item in m_paymentform.items" :key="item.id" :value="item.id">
                        {{ item.name_kg }}
                      </option>
                    </template>
                  </select>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-2">
                  <label for="select_1_1">Окуу тили <span>*</span></label>
                  <select
                    class="custom-select"
                    id="select_1_1"
                    v-model="m_language.id"
                    required
                  >
                    <option value="null" selected disabled>-- выбрать --</option>
                    <template v-if="m_language.items != null">
                      <option v-for="item in m_language.items" :key="item.id" :value="item.id">
                        {{ item.name }}
                      </option>
                    </template>
                  </select>
                </div>
              </div>
            </div>
            <div class="form-group mb-2">
              <label for="select_1_1">Жарандыгы <span>*</span></label>
              <select
                class="custom-select"
                id="select_1_1"
                v-model="m_citizenship.id"
                required
              >
                <option value="null" selected disabled>-- выбрать --</option>
                <template v-if="m_citizenship.items != null">
                  <option v-for="item in m_citizenship.items" :key="item.id" :value="item.id">
                    {{ item.name }}
                  </option>
                </template>
              </select>
            </div>
            <div class="form-group mb-2">
              <label for="select_1_1">Кыргыз тилин билүү дэңгээли <span>*</span></label>
              <select
                class="custom-select"
                id="select_1_1"
                v-model="m_till_biluu.id"
                required
              >
                <option value="null" selected disabled>-- выбрать --</option>
                <template v-if="m_till_biluu.items != null">
                  <option v-for="item in m_till_biluu.items" :key="item.id" :value="item.id">
                    {{ item.name }}
                  </option>
                </template>
              </select>
            </div>
          </div>
          
        </div>
        <hr>
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label for="select_1_3">Приказ №</label>
              <input type="text" class="form-control" v-model="enrollmentData.order"/>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label for="select_1_3">Дата</label>
              <input type="date" class="form-control" v-model="enrollmentData.order_date"/>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group mb-2">
              <label for="select_1_1">Движение <span>*</span></label>
              <select
                class="custom-select"
                id="select_1_1"
                v-model="m_movement.id"
                required
              >
                <option value="null" selected disabled>-- выбрать --</option>
                <template v-if="m_movement.items != null">
                  <option v-for="item in m_movement.items" :key="item.id" :value="item.id">
                    {{ item.name_kg }}
                  </option>
                </template>
              </select>
            </div>
          </div>
          
        </div>
                
      </template>

      <template v-slot:footer>
        <button
          type="button"
          class="btn btn-danger mr-3"
          @click="enrollmentModal = false"
        >
          Отмена
        </button> 
        <button
          type="submit"
          class="btn btn-primary"
          :disable="isSubmit"
          @click.prevent="export_m"
        >
          Подтвердить
        </button>       
      </template>
 
    </Modal>
    <template>
      <div>
        <vue-html2pdf
          :show-layout="false"
          :float-layout="true"
          :enable-download="false"
          :preview-modal="true"
          :paginate-elements-by-height="800"
          filename="Ex. list"
          :pdf-quality="2"
          :manual-pagination="false"
          pdf-format="a4"
          pdf-orientation="landscape"
          pdf-content-width="1130px"
          ref="html2Pdf"
        >
          <section slot="pdf-content">
            <div class="pdfContainer">
              <template>
                <div class="text-right fs_small mb-2">
                  <div >Шифр<span class="bb_L" style="width: 4rem;">  </span></div>                    
                  <div class="wsnw">(кабыл алуу комиссиясынын жоптуу катчысы толтурат)</div>                    
                </div>
                <div class="row">
                  <div class="col-6">
                    <h3 class="text-center">ЭСКЕРТҮҮ</h3>
                    <div class="mb-3">1. Сынак барагы сынакка кирүүдө  уруксат-нааманын кызматын аткарат.</div>
                    <div class="mb-3">2. Сынактар оозеки, жазуу жана бланкалык тест түрүндө   өткөрүлөт.</div>
                    <div class="mb-3">3. Сынакка кечиккендер же учурунда келбегендер кабыл алуу комиссиясынын уруксаты менен сынакка катышышат.</div>
                    <div class="mb-3">4. Кирүү сынактары бүткөндөн кийин сынак барагы кабыл алуу комиссиясына тапшырылат.</div>
                    <div class="mb-5">5. Окуу жайына кабыл алынбагандар  өздөрүнүн документтерин сынак барагын калтыргандан кийин гана ала алышат.</div>
                    <h3 class="text-center">ОшМУнун кабыл алуу комиссиясы</h3>
                  </div>                  

                  <div class="col-6">
                    <h3 class="text-center">Ош мамлекеттик университети</h3>
                    <div class="row">
                      <div class="col-4"><span class="text_v">Факультет:</span></div>
                      <div class="col-8">{{ exData.fak }}</div>
                    </div>
                    <div class="row">
                      <div class="col-4"><span class="text_v">Адистиги /Багыты:</span></div>
                      <div class="col-8">{{ exData.spec }}</div>
                    </div>
                    <div class="row">
                      <div class="col-4"><span class="text_v">Окутуу формасы:</span></div>
                      <div class="col-8">{{ exData.eduform }}</div>
                      <!-- <div class="col-8">Күндүзгү бакалавр (Контракт)</div> -->
                    </div>
                    <div class="row">
                      <div class="col-4"><span class="text_v">Окутуу тили:</span></div>
                      <div class="col-8">{{ exData.lang }}</div>
                    </div>
                    <div class="row mb-2">
                      <div class="col-4"><span class="text_v">Жарандыгы:</span></div>
                      <div class="col-8">{{ exData.country_live_name }}</div>
                    </div>
                    <div class="row mb-2">
                      <div class="col-3">
                        <div class="userFoto2">
                          <img :src="exData.foto" alt="">
                        </div>
                      </div>
                      <div class="col-9">
                        <h3 class="text-center mb-3">СЫНАК БАРАГЫ</h3>
                        <h4 class="text-center mb-3">{{ exData.student }}</h4>
                        <div class="text-center">Регистрациондук №: {{ exData.reg }}</div>
                      </div>
                    </div>                    
                    <div class="row">
                      <div class="col-6"><span class="text_v">Кирүү сынагына уруксат берилген:</span></div>
                      <div class="col-6 text-right"><span>{{ exData.dd1 }}, {{ exData.toktom }} токтом</span></div>
                      <!-- <div class="col-6 text-right"><span>2022-жылы 12-декабрь №1 токтом</span></div> -->
                    </div>
                    <div class="row">
                      <div class="col-4"><span class="text_v">Берилген күнү:</span></div>
                      <div class="col-8 text-right"><span>{{ exData.dd2 }}</span></div>
                    </div>
                    <div class="row">
                      <div class="col-6"><span class="text_v">Кабыл алуу комиссиясынын жооптуу катчысы:</span></div>
                      <div class="col-6 text-right">
                        <div>{{ otvet }}</div>
                        <div style="vertical-align: sub;">
                          <span class="fs_small">(колу)</span> <span class="bb_L" style="width: 10rem;"></span>
                        </div>
                      </div>
                    </div>
                    <div class="text-right"></div>
                    <div class="mb-2">
                      <span class="text_v mr-3">Кирүүчүнүн колу:</span>
                      <span class="bb_L" style="width: 10rem;"></span>
                    </div>
                    <h5 class="text-center">Кирүү сынактары жана алардын варианттары:</h5>
                    <table>
                      <thead>
                        <th width="10">#</th>
                        <th>Сабактын аты</th>
                        <th>Тест вариант</th>
                      </thead>
                      <tbody>
                        <tr>
                          <td class="text-center">1</td>
                          <td>{{ exData.subject1 }}</td>
                          <td></td>
                        </tr>
                        <template v-if="exData.subject2==''">
                          <tr>
                            <td class="text-center">2</td>
                            <td>{{ exData.subject3 }}</td>
                            <td></td>
                          </tr>
                          
                        </template>
                        <template v-else>
                          <tr>
                            <td class="text-center">2</td>
                            <td>{{ exData.subject2 }}</td>
                            <td></td>
                          </tr>
                          <tr>
                            <td class="text-center">3</td>
                            <td>{{ exData.subject3 }}</td>
                            <td></td>
                          </tr>
                        </template>                                               
                      </tbody>
                    </table>
                  </div>
                </div>

               
              </template>
            </div>
          </section>
        </vue-html2pdf>
      </div>
    </template>
  </div>  
</template>
<script>
import xlsx from "json-as-xlsx";
import VueHtml2pdf from "vue-html2pdf";
import Modal from "@/components/others/Modal.vue";
import * as moment from 'moment';
import 'moment/locale/pt-br';
import _ from "lodash";
import axios from "axios";
export default {
  name: "DocumentsList",
  components: {VueHtml2pdf, Modal},
  data() {
    return {
      enrollmentModal: false,
      page: 1,
      perPage: 10,
      perPageArr: [5, 10, 15, 25, 50, 100, 500, 1000],
      searchByFio: "",
      is_ex: false,
      enrollmentData: {
        id: null,
        f: '',
        i: '',
        o: '',
        foto: '',
        passport1_file: '',
        passport2_file: '',
        ort_file: '',
        id_citizenship: null,
        citizenship_name: '',
        id_f_o: null,
        f_o: '',
        id_type_o: null,
        type_o: '',
        id_faculty: null,
        id_direction: null,
        id_spes: null,
        id_language_o: null,
        id_state_language_level: null,
        language_o_name: '',
        order: '',
        order_date: new Date().toISOString().split('T')[0],
      },
      exData: {
        id: 0,
        student: '',
        fak: '',
        spec: '',
        subject1: '',
        subject2: '',
        subject3: '',
        foto: '',
        eduform: '',
        lang: '',
        reg: '',
        toktom: '',
        country_live_name: '',
        date1: new Date().toISOString().split('T')[0],
        date2: new Date().toISOString().split('T')[0],  
        dd2: ''      
      },

      fak: { disabled: true, items: null, val: 0 },
      direction: { disabled: true, items: null, val: 0 },
      spec: { disabled: true, items: null, val: 0 },
      type_o: { disabled: true, items: null, val: 0 },
      f_o: { disabled: true, items: null, val: 0 },
      lang: { disabled: true, items: null, val: 0 },

      tur: { items: null, val: 0 },
      exam_subject1: { items: [], id: null },
      exam_subject2: { items: [], id: null },
      otvet: '',
      documets: { data: [], links: [] },
      status: 0,
      dataLoading: false,

      m_fak: { disabled: true, items: null, id: null },
      m_direction: { disabled: true, items: null, id: null },
      m_spec: { disabled: true, items: null, id: null },
      m_period: { disabled: true, items: null, id: null },
      m_eduyear: { disabled: true, items: null, id: null },
      m_eduform: { disabled: true, items: null, id: null },
      m_language: { disabled: true, items: null, id: null },
      m_paymentform: { disabled: true, items: null, id: null },
      m_citizenship: { disabled: true, items: null, id: null },
      m_movement: { disabled: true, items: null, id: null },
      m_till_biluu: { items: [], id: null },
      
      filter: {
        status_proverka: false,
        status_prinyat: false,
        status_print: false,
        status_avn: false,
      },
      optionsBlock: false      
    };
  },
  created() {
    if (this.$route.params.status != undefined) {
      this.status = this.$route.params.status;
    }
  },
  computed: {
    isSubmit(){
      if (
        this.m_fak.id != null &&    
        this.m_direction.id != null &&     
        this.m_spec.id != null &&
        this.m_period.id != null &&
        this.m_eduyear.id != null &&
        this.m_eduform.id != null &&
        this.m_language.id != null &&
        this.m_citizenship.id != null &&
        this.m_paymentform.id != null &&
        this.m_movement.id != null &&
        this.m_till_biluu.id != null
      ) return true
      return false
    },
    isAllfilter(){
      return (this.filter.status_proverka || 
              this.filter.status_prinyat || 
              this.filter.status_print || 
              this.filter.status_avn)
    },
    is_exBtn(){
      return this.is_ex && this.exam_subject1.id && this.exData.toktom!==''
    }
  },
  methods: {
    exToggle(){
      this.is_ex = !this.is_ex 
    },
    enrollmentModalShow(stud){
      this.enrollmentData.id = stud.id,
      this.enrollmentData.f = stud.f,
      this.enrollmentData.i = stud.i,
      this.enrollmentData.o = stud.o,
      this.enrollmentData.foto = 'https://registration.portal.oshsu.kg/storage/photo34/' + stud.document_file.foto34_file,
      this.enrollmentData.passport1_file = 'https://registration.portal.oshsu.kg/storage/doc/' + stud.document_file.passport1_file,
      this.enrollmentData.passport2_file = 'https://registration.portal.oshsu.kg/storage/doc/' + stud.document_file.passport2_file,
      this.enrollmentData.ort_file = 'https://registration.portal.oshsu.kg/storage/doc/' + stud.document_file.ort_file,
      this.enrollmentData.id_citizenship = stud.id_citizenship,
      this.enrollmentData.citizenship_name = stud.citizenship_name.name_ru,
      this.enrollmentData.id_f_o = stud.id_f_o,
      this.enrollmentData.f_o = this.getIdValue(this.f_o.val, this.f_o.items, 'name_ru'),
      this.enrollmentData.id_type_o = stud.id_type_o,
      this.enrollmentData.type_o = this.getIdValue(this.type_o.val, this.type_o.items, 'name_ru'),
      this.enrollmentData.id_faculty = this.getIdValue(this.fak.val, this.fak.items, 'name_ru'),
      this.enrollmentData.id_direction = this.getIdValue(this.direction.val, this.direction.items, 'name_ru'),
      this.enrollmentData.id_spes = this.getIdValue(this.spec.val, this.spec.items, 'name_ru'),
      this.enrollmentData.id_language_o = stud.id_language_o,   
      this.enrollmentData.language_o_name = stud.language_o_name.name_kg
      this.enrollmentModal = true 
      this.m_fak.id = null     
      this.m_direction.id = null     
      this.m_spec.id = null     
      this.m_period.id = null     
      this.m_eduyear.id = null     
      this.m_eduform.id = null     
      this.m_language.id = null     
      this.m_paymentform.id = null  
      this.m_citizenship.id = null
      this.m_movement.id = null
      this.m_till_biluu.id = null

      this.getMYEDU_Fak()
      this.getMYEDU_Period()
      this.getMYEDU_Year()
      this.getMYEDU_EduForm()
      this.getMYEDU_Language()
      this.getMYEDU_Paymentform()
      this.getMYEDU_Citizenship()
      this.getMYEDU_Movement()

    },
    async getMYEDU_Fak() {
      try {
        const {data} = await axios.get('https://api.myedu.oshsu.kg/public/api/open/faculty')
        this.m_fak.items = data;
        this.m_fak.disabled = false;
        if(this.m_fak.items.some(el=>el.id==this.fak.val)){
          this.m_fak.id = this.fak.val
          this.getMYEDU_Dir()
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getMYEDU_Dir() {
      this.m_direction.id = null;
      try {
        const {data} = await axios.get('https://api.myedu.oshsu.kg/public/api/open/direction', {params: {id_faculty: this.m_fak.id}})
        this.m_direction.items = data;
        this.m_direction.disabled = false;
        if(this.m_direction.items.some(el=>el.id==this.direction.val)){
          this.m_direction.id = this.direction.val
          this.getMYEDU_Spec()
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getMYEDU_Spec() {
      this.m_spec.id = null;
      try {
        const {data} = await axios.get('https://api.myedu.oshsu.kg/public/api/open/speciality', {params: {id_direction: this.m_direction.id}})
        this.m_spec.items = data;
        this.m_spec.disabled = false;
        if(this.m_spec.items.some(el=>el.id==this.spec.val)){
        this.m_spec.id = this.spec.val
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getMYEDU_Period() {
      try {
        const {data} = await axios.get('https://api.myedu.oshsu.kg/public/api/open/period')
        this.m_period.items = data;
        this.m_period.disabled = false;
        if(this.m_period.items.length){
          this.m_period.id = this.m_period.items[0].id
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getMYEDU_Year() {
      try {
        const {data} = await axios.get('https://api.myedu.oshsu.kg/public/api/open/eduyear')
        this.m_eduyear.items = data;
        this.m_eduyear.disabled = false;
        if(this.m_eduyear.items.length){
          this.m_eduyear.id = this.m_eduyear.items[this.m_eduyear.items.length-1].id
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getMYEDU_EduForm() {
      try {
        const {data} = await axios.get('https://api.myedu.oshsu.kg/public/api/open/eduform')
        this.m_eduform.items = data;
        this.m_eduform.disabled = false;
        if(this.m_eduform.items.some(el=>el.id==this.enrollmentData.id_f_o)){
          this.m_eduform.id = this.enrollmentData.id_f_o
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getMYEDU_Language() {
      try {
        const {data} = await axios.get('https://api.myedu.oshsu.kg/public/api/open/language')
        this.m_language.items = data;
        this.m_language.disabled = false;
        if(this.m_language.items.some(el=>el.id==this.enrollmentData.id_language_o)){
          this.m_language.id = this.enrollmentData.id_language_o
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getMYEDU_Paymentform() {
      try {
        const {data} = await axios.get('https://api.myedu.oshsu.kg/public/api/open/paymentform')
        this.m_paymentform.items = data;
        this.m_paymentform.disabled = false;
        if(this.m_paymentform.items.some(el=>el.id==this.enrollmentData.id_type_o)){
          this.m_paymentform.id = this.enrollmentData.id_type_o
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getMYEDU_Citizenship() {
      try {
        const {data} = await axios.get('https://api.myedu.oshsu.kg/public/api/open/citizenship')
        this.m_citizenship.items = data;
        this.m_citizenship.disabled = false;        
      } catch (error) {
        console.log(error);
      }
    },
    async getMYEDU_Movement() {
      try {
        const {data} = await axios.get('https://api.myedu.oshsu.kg/public/api/open/movements')
        this.m_movement.items = data;
        this.m_movement.disabled = false;        
      } catch (error) {
        console.log(error);
      }
    },
    export_m (){
      if(this.isSubmit) this.export__myedu()
    },
    async export__myedu() {
      const query = {
        id_doc: this.enrollmentData.id,
        order: this.enrollmentData.order,
        order_date: this.enrollmentData.order_date,
        id_faculty: this.m_fak.id,
        id_direction: this.m_direction.id,
        id_speciality: this.m_spec.id,
        id_period: this.m_period.id,
        id_eduyear: this.m_eduyear.id,
        id_eduform: this.m_eduform.id,
        id_language: this.m_language.id,
        id_citizenship: this.m_citizenship.id,
        id_paymentform: this.m_paymentform.id,
        id_state_language_level: this.m_till_biluu.id,
        id_movement_info: this.m_movement.id
        
      }
      try {
        await this.$api.documents.export__myedu(query)   
        this.$nt("Успешно зарегистрирован", "success");     
        this.get_document(); 
      } catch (error) {
        this.$nt("Ошибка", "danger");
        console.log(error);
      } finally{ this.enrollmentModal = false; }
    },

    getIdValue(id, items, field){
      if(items) {
        const item = items.find(i=>i.id == id)
        if(item) return item[field]
        return ''
      } else  return ''
    },
    printPDF(stud){
      moment.locale('ky');
      this.exData.student = `${stud.f} ${stud.i} ${stud.o}` 
      this.exData.country_live_name = stud.country_live_name.name_kg
      this.exData.reg = stud.id
      this.exData.foto = 'https://registration.portal.oshsu.kg/storage/photo34/' + stud.document_file.foto34_file
      this.exData.fak = this.getIdValue(this.fak.val, this.fak.items, 'name_kg')
      this.exData.spec = this.getIdValue(this.spec.val, this.spec.items, 'name_kg')
      this.exData.lang = this.getIdValue(stud.id_language_o, this.lang.items, 'name_for_list')
      this.exData.eduform = `${this.getIdValue(this.f_o.val, this.f_o.items, 'name_kg')} (${this.getIdValue(this.type_o.val, this.type_o.items, 'name_kg')})`
      this.exData.subject1 = this.getIdValue(this.exam_subject1.id, this.exam_subject1.items, 'name')
      this.exData.subject2 = this.getIdValue(this.exam_subject2.id, this.exam_subject1.items, 'name')
      this.exData.subject3 = this.getIdValue(stud.id_language_o, this.lang.items, 'name_for_exam')
      this.exData.dd1 = moment(this.exData.date1).format('LL') 
      this.exData.dd2 = moment(this.exData.date2).format('LL') 
      this.$refs.html2Pdf.generatePdf();
    },
    goStatement(id) {
      this.$router.push({
        name: "StatementEdit",
        params: {
          status: 1,
          id: id,
        },
      });
    },
    slectPage(i) {
      let p = this.documets.links[i];
      if (parseInt(p.label)) {
        this.page = parseInt(p.label);
        this.get_document();
      } else {
        if (p.label == "&laquo; Previous" && p.url != null) {
          this.page--;
          this.documets = {}
          this.get_document();
        }
        if (p.label == "Next &raquo;" && p.url != null) {
          this.page++;
          this.documets = {}
          this.get_document();
        }
      }
    },
    perPageChange() {
      this.get_document();
    },
    downloadFile() {
      let data = [
        {
          sheet: "Документ",
          columns: [
            { label: "#", value: "num" },
            { label: "id", value: "id" },
            { label: "ФИО", value: (row)=> row.f+' '+row.i+' '+row.o },  
            { label: "Туулган жылы", value: "birthday" },
            { label: "Бүтүргөн жылы мектеби аттестаты", value: (row)=> row.sc+' '+row.sName+' №'+row.dip},
            { label: "Жашаган жери", value: (row)=> row.cn+', '+row.ob+', '+row.rn },
          ],
          content: this.documets.data.map((еl, index)=>({
              id: еl.id,
              num: index+1,
              f: еl.f,
              i: еl.i,
              o: еl.o,
              birthday: еl.birthday,
              sc: еl.school_year_end,
              sName: еl.school_name.name_kg || '',
              dip: еl.diplom_info,
              cn: еl.country_live_name.name_kg || '',
              ob: еl.oblast_live_name.name_kg || '',
              rn: еl.rayon_live_name.name_kg || '',
            })),
        },
      ];
      let settings = {
        fileName: "Документ",
        extraLength: 5,
      };
      xlsx(data, settings);
    },
    async getFak() {
      try {
        const data = (await this.$api.edu_spec.faculty()).data;
        this.fak.items = data;
        this.fak.disabled = false;
      } catch (error) {
        console.log(error);
      }
    },
    async getDirection() {
      try {
        const data = (
          await this.$api.edu_spec.direction({
            id_faculty: this.fak.val,
          })
        ).data;
        this.direction.items = data;
        this.direction.disabled = false;
      } catch (error) {
        console.log(error);
      }
    },
    async getSpec() {
      try {
        const data = (
          await this.$api.edu_spec.speciality({
            id_direction: this.direction.val,
          })
        ).data;
        this.spec.items = data;
        this.spec.disabled = false;
      } catch (error) {
        console.log(error);
      }
    },
    async getType_o() {
      try {
        const data = (
          await this.$api.edu_spec.type_o({
            id_spes: this.spec.val,
          })
        ).data;
        this.type_o.items = data;
        this.type_o.disabled = false;
      } catch (error) {
        console.log(error);
      }
    },
    async getF_o() {
      try {
        const data = (
          await this.$api.edu_spec.f_o({
            id_spes: this.spec.val,
            id_type_o: this.type_o.val,
          })
        ).data;
        this.f_o.items = data;
        this.f_o.disabled = false;
      } catch (error) {
        console.log(error);
      }
    },
    async list_info() {
      try {
        const data = (await this.$api.map.list_info()).data;
        this.tur.items = data.tur;
        this.otvet = data.otvet;
        this.lang.items = data.lang;
        this.exam_subject1.items = data.exam_subject;
        this.exam_subject2.items = data.exam_subject;
        this.m_till_biluu.items = data.till_biluu;
      } catch (error) {
        console.log(error);
      }
    },
    async get_document() {
      this.dataLoading = true
      try {
        const data = (
          await this.$api.documents.get_document({
            id_faculty: this.fak.val,
            id_direction: this.direction.val,
            id_spes: this.spec.val,
            id_type_o: this.type_o.val,
            id_f_o: this.f_o.val,
            id_tur: this.tur.val,
            page: this.page,
            perPage: this.perPage,
            status_proverka: +this.filter.status_proverka,
            status_prinyat: +this.filter.status_prinyat,
            status_print: +this.filter.status_print,
            status_avn: +this.filter.status_avn,
            searchByFio: this.searchByFio
          })
        ).data;
        this.documets = data;
        this.dataLoading = false
      } catch (error) {
        console.log(error);
      }
    },
    fakSelect() {
      this.direction.val = 0;
      this.spec.val = 0;
      this.type_o.val = 0;
      this.f_o.val = 0;
      this.tur.val = 0;
      this.optionsBlock = false
      this.documets = { data: [], links: [] };
      this.getDirection();
    },
    directionSelect() {
      this.spec.val = 0;
      this.type_o.val = 0;
      this.f_o.val = 0;
      this.tur.val = 0;
      this.optionsBlock = false
      this.documets = { data: [], links: [] };
      this.getSpec();
    },
    specSelect() {
      this.type_o.val = 0;
      this.f_o.val = 0;
      this.tur.val = 0;
      this.optionsBlock = false
      this.documets = { data: [], links: [] };
      this.getType_o();
    },
    type_oSelect() {
      this.f_o.val = 0;
      this.tur.val = 0;
      this.optionsBlock = false
      this.documets = { data: [], links: [] };
      this.getF_o();
    },
    f_oSelect() {
      this.tur.val = 0;
      this.optionsBlock = false
      this.documets = { data: [], links: [] };
    },
    turSelect() {
      this.optionsBlock = true
      this.get_document();
    },
    async goo() {
      if (this.status) {
        this.fak.val = this.$route.params.fak;
        await this.getDirection();
        this.direction.val = this.$route.params.direction;
        await this.getSpec();
        this.spec.val = this.$route.params.spec;
        await this.getType_o();
        this.type_o.val = this.$route.params.type_o;
        await this.getF_o();
        this.f_o.val = this.$route.params.f_o;
        this.tur.val = this.$route.params.tur;
        await this.get_document();
      }
    },
    async status_avn_api(id) {
      try {
        await this.$api.others.status_avn({
          id_user: id,
          status: 1,
        });
        this.$nt("Статус изменен", "success");
      } catch (error) {
        this.$nt("Ошибка", "danger");
        console.log(error);
      }
    },
    fAllCheck(){
      this.filter.status_proverka = false
      this.filter.status_prinyat = false
      this.filter.status_print = false
      this.filter.status_avn = false
      this.page = 1
      this.get_document()
    },
    f_proverka(){
      this.filter.status_proverka = !this.filter.status_proverka
      this.page = 1
      this.get_document()
      console.log('sdfdsfsdf');
    },
    f_prinyat(){
      this.filter.status_prinyat = !this.filter.status_prinyat
      this.page = 1
      this.get_document()
    },
    f_print(){
      this.filter.status_print = !this.filter.status_print
      this.page = 1
      this.get_document()
    },
    f_avn(){
      this.filter.status_avn = !this.filter.status_avn
      this.page = 1
      this.get_document()
    },
    searchFio(){       
      this.page = 1       
      this.get_document().then(()=>{
        this.searchByFio = ''
      })      
    },
    searchClear(){
      this.searchByFio = ''
      this.get_document()
    },
    searchInput(){
      if (this.searchByFio.length>3 || this.searchByFio.length==0) this.antiRebote(this.get_document)      
    },
    antiRebote: _.debounce((cb, arg)=>{cb(arg)}, 350),

  },
  mounted() {
    this.$nextTick(function () {
      this.getFak();
      this.list_info();
      this.goo();
    });
  },
};
</script>
<style lang="scss" scoped>
td:last-child, th:last-child {
  word-wrap: none;
}
@media (min-width: 767.8px) {  
  .br1{
    border-right: 1px solid rgba(0,0,0,0.2);
  }
}
.wsnw{
  white-space: nowrap
}
.statusIcon {
  display: inline-block;
  width: 30px;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  background-color: rgba(222, 68, 54, 0.1);
  border-color: transparent;
  color: #de4436;
  font-weight: 500;
  text-align: center;
  border-radius: 0.2rem;
  vertical-align: bottom;
  &.status_proverka {
    background-color: #00c9a7;
    border-color: #00c9a7;
    color: #fff;
  }
  &.status_prinyat {
    background-color: #3f87f51a;
    border-color: #3f87f5;
    color: #3f87f5;
  }
  &.status_print {
    background-color: #02d3ef;
    border-color: #02d3ef;
    color: #fff;
  }
  &.status_avn {
    background-color: #886cff;
    border-color: #886cff;
    color: #fff;
  }  
}
.filter{
  padding-right: 5px;
  .btn-default {
    color: #9b9b9b;
    background-color: #fff;
    border-color: #cfcfcf;
  }
  .btn-default:hover{
    color: #3f87f5;
    background-color: #3f87f500;
    border-color: #3f87f5;
  }
  .btn-default:active, .btn-default.active {
    background-color: #3f87f5;
    border-color: #3f87f5;
    color: #f9f9f9;
  }
  .all.btn-icon.btn-sm {
    width: auto;
    padding-right: .5em;
    padding-left: .5em;
  }
}
.input-affix .form-control-sm {
   padding: 0.3rem 35px;
}
.pdfContainer {
  color: #000;
  padding: 35px;
  img{max-width: 100%;}
  b{vertical-align: middle;}
  .fs_small{
    font-size: .7rem;
  }
  .userFoto2 {
    min-height: 130px;
    border: 1px dashed gray;
    padding: 3px;
  }
  .text_v {
    font-weight: 600;
    vertical-align:sub
  }
  hr {
    border-top: 1px dashed #c9c9c9;
    margin-top: 7px;
    margin-bottom: 5px;
  }
  .info_block {
    margin-right: 1.5em;
  }
  .br {
    border-right: 1px dashed #c9c9c9;
  }
  .section {
    background-color: rgb(212, 212, 212);
    color: rgb(0, 0, 0);
    padding: 3px 5px;
    font-weight: 500;
    text-align: center;
  }
  .info_sm {
    background-color: #e0e0e0;
    font-size: 10px;
    color: rgb(0, 0, 0);
    line-height: 12px;
    padding: 5px 5px;
  }
  .footer {
    font-size: 0.7em;
    text-align: right;
    font-weight: 100;
    text-transform: uppercase;
    color: #000;
    padding: 0;
  }
  .b_b {
    color: gray;
  }
  .bb_L{
    display: inline-block;
    vertical-align: bottom;
    line-height: 1.2rem;
    height: 1.2rem;
    width: 100%;
    border-bottom: 1px solid #000;
  }
  table{
    width: 100%;
    border-collapse: collapse;
    border-bottom: 1px solid #000;
    border-right: 1px solid #000;
    td, th{
      border-top: 1px solid #000;
      border-left: 1px solid #000;
      padding: 0 5px;
    }
  }
}
</style>
